module.exports = __webpack_public_path__ + "static/media/state1.png";